// Re-export all functions from player-core.js, player-ui.js and toggle.js for backward compatibility
import { restoreAudioPlayerState } from './audio-player/player-core.js';

export {
	showAudioPlayer,
	updateAudioPlayerTrack,
	hideAudioPlayer,
	getAudioPlayerState,
	setAudioPlayerState,
	getAudioPlayerElement,
	getAudioPlayerCollapsed,
	getCurrentAudioFile,
	AUDIO_PLAYER_WIDTH,
	AUDIO_PLAYER_HEIGHT,
	fadeInVolume,
	restoreAudioPlayerState
} from './audio-player/player-core.js';

export {
	animatePlayerCollapse,
	setupMediaSession,
	clearMediaSession,
	setupPlayerUI
} from './audio-player/player-ui.js';

export {
	initAudioPlayerToggle,
	showAudioPlayerToggle,
	hideAudioPlayerToggle,
	showPlayPauseIcon,
	toggleAudioPlayerCollapse
} from './audio-player/toggle.js';

export {
	initPlayerStatePersistence,
	cleanupPlayerStatePersistence,
	loadSavedState,
	clearSavedState
} from './audio-player/player-state.js';

// Make restoreAudioPlayerState available globally for load-data.js
if (typeof window !== 'undefined') {
	window.restoreAudioPlayerState = restoreAudioPlayerState;
}
